// Müşteri bağlantısı (/offers/view/*) için yedek bilgi sayfası.
//
// Canlıda bu adresi sunucu kendisi karşılar: /offers/view/<ad>-<id>.pdf → teklif PDF'i, diğer her şey → bilgi sayfası.
// Bu React sayfası yalnızca geliştirme ortamında ya da beklenmedik bir durumda açılır. Bilerek HİÇBİR API isteği atmaz
// ve müşteri verisi göstermez: adresteki numarayı değiştirerek başka bir teklif görülemez.
import React from 'react';
import { FileText, Phone, Mail, Globe } from 'lucide-react';

const CONTACTS = [
  { icon: Phone, label: '444 1 344', href: 'tel:4441344' },
  { icon: Mail, label: 'info@ramadaergan.com', href: 'mailto:info@ramadaergan.com' },
  { icon: Globe, label: 'www.ramadaergan.com', href: 'https://www.ramadaergan.com', external: true },
];

export default function PublicOffer() {
  return (
    <main className="min-h-screen w-full bg-gray-100 dark:bg-gray-900 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 sm:p-8 text-center">
        <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center">
          <FileText size={28} aria-hidden="true" />
        </div>
        <p className="text-xs font-semibold tracking-wide text-gray-500 dark:text-gray-400 uppercase">Ramada by Wyndham Ergan</p>
        <h1 className="mt-2 text-xl font-bold text-gray-900 dark:text-white">Teklif bağlantınız güncellendi.</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-300">
          Güncel teklifiniz için lütfen bizimle iletişime geçin.
        </p>

        <ul className="mt-6 space-y-2 text-left">
          {CONTACTS.map(({ icon: Icon, label, href, external }) => (
            <li key={href}>
              <a
                href={href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="flex items-center gap-3 rounded-lg border border-gray-200 dark:border-gray-700 px-4 py-3 text-sm font-medium text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors break-all"
              >
                <Icon size={18} className="shrink-0 text-blue-600 dark:text-blue-400" aria-hidden="true" />
                <span>{label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
